module.exports = __webpack_public_path__ + "media/images/resource/cart-4-7e5f57e201374f07a91a48c00fe07d9b.png";